import React, {useState} from 'react'
import Box from '@material-ui/core/Box'
import TextField from '@material-ui/core/TextField'
import { BlueButton } from '../Components/Buttons'
import { useHistory } from 'react-router-dom'
import queryString from 'query-string'
import Styles from '../Styles/Styles'
import Alert from '@material-ui/lab/Alert';
import Wrapper from "../Components/Wrapper";
import OverlayLoader from "../Components/OverlayLoader";
import isEmail from "validator/lib/isEmail";

function WhereIsMyISN() {
    const history = useHistory();
    const classes = Styles({});
    const [email, setEmail] = useState('');
    const [isLoading, setIsLoading] = React.useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const [isRequiredFieldMissing, setIsRequiredFieldMissing] = useState(false);

    const handleSubmit = (event:any) => {
        if(!isEmail(email)) {
            setErrorMessage('Please enter a valid email address.');
            setIsRequiredFieldMissing(true);
        } else {
            setErrorMessage('');
            setIsRequiredFieldMissing(false);
            setIsLoading(true);
            (async () => {
                const res = await fetch(`${process.env.REACT_APP_FIND_ISN_COMPANY_URL}?notice=1&email=${email}`, {
                    method: 'GET',
                });
                const results = await res.json();
                setIsLoading(false);

                if (results.count === 1) {
                    history.push(`/found/${queryString.stringify({ck: results.companyKey, 'url': results.url})}`);
                } else if (results.count > 1) {
                    history.push(`/multiple-key/${email}`);
                } else {
                    history.push('/no-isn-found');
                }
            })();
        }
    }
    const handleOnChangeEmail = (e:any) => {
        setIsLoading(false);
        setEmail(e.target.value)
        e.target.value === '' ? setIsRequiredFieldMissing(true) : setIsRequiredFieldMissing(false);
    }

    return (
        <>
            <Wrapper>
                <Box className={classes.logoContainer}><img width="140" alt="ISN" src={process.env.REACT_APP_ISN_LOGO} /></Box>
                <p className={classes.info}>Every ISN account has a company key which is required to log in. We can help you find yours with your email address.</p>
                {errorMessage && isRequiredFieldMissing && <Alert severity={'error'}>{errorMessage}</Alert>}
                <Box className={classes.inputBox}>
                    <TextField
                        fullWidth
                        InputProps={{
                            className: isRequiredFieldMissing && email === '' ? classes.inputError : classes.input,
                            disableUnderline: true,
                        }}
                        id="email" label="Email address" type="text" variant="filled" onChange={handleOnChangeEmail} />
                </Box>
                <Box className={classes.inputBox}>
                    <BlueButton disabled={isLoading} fullWidth className={classes.button} onClick={handleSubmit}>
                        Find my ISN
                        </BlueButton>
                </Box>
                <Box className={classes.linkBox}>
                    <p className={classes.sameLineLink}>
                        <a href={process.env.REACT_APP_FIND_ISN_HOME} className={classes.link}>Learn about ISN</a>
                    </p>
                    <p className={classes.sameLineLinkPipe}></p>
                    <p className={classes.sameLineLink}>
                        <a href={process.env.REACT_APP_FIND_ISN_CONTACT} className={classes.link}>Contact Us</a>
                    </p>
                </Box>
            </Wrapper>
            <OverlayLoader open={isLoading} thickness={5} size={50}/>
        </>

    );
};

export default WhereIsMyISN